<div class="layout-content">
	<div class="grid">
		<div class="col-12">
			<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
				[ngClass]="simpleInputTextLayout('borderRow')">
				<div class="flex align-items-center justify-content-center gap-2" [ngClass]="simpleInputTextLayout('label')">
					{{ 'FILE_UPLOAD' | translate }}
					<p-button *ngIf="!this.onExtendedMobile()"
						pTooltip="{{ 'READ_INFO_FOR' | translate }} {{ 'IMPORT_DATAS_FROM_FILE' | translate }}" tooltipPosition="bottom"
						(click)="infoDialogGenericEntry()" icon="pi cm-alert" size="large" [rounded]="false" [text]="true" severity="warning">
					</p-button>
				</div>
				<div class="flex align-items-end justify-content-center" [ngClass]="simpleInputTextLayout('borderInput')">
					<p-fileUpload *ngIf="!reuploadButton && !showUploadedFileLabel" mode="basic"
						chooseLabel="{{ 'FILE_UPLOAD' | translate }}" type="file" (onSelect)="handleFileInput($event)"
						[ngClass]="dynamicInputTextWidth()" styleClass="pr-6 {{dynamicInputTextWidth()}}">
						>
					</p-fileUpload>
					<div *ngIf="showUploadedFileLabel" class="flex align-items-center text-blue-900">
						<div class="mr-2">{{ labelFile }}</div>
					</div>
					<button *ngIf="reuploadButton" pButton pRipple type="button" id="custom-email-permission-upload-cancel"
						label="{{ 'UPLOAD_OTHER_FILES' | translate }}" icon="pi cm-plus"
						class="p-button-primary p-button-text border-noround-bottom" size="small" (click)="uploadInit()">
					</button>
				</div>
			</div>
		</div>
		<div class="col-12">
			<textarea class="w-full" id="float-input" rows="10" cols="80" pInputTextarea
				[(ngModel)]="processText" [readOnly]="true"></textarea>
		</div>
	</div>

	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
			class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1" [ngClass]="dynamicButtonWidth()">
		</button>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>